import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { DetailsTabComponent } from './details-tab/details-tab.component';
import { CandidatesTabComponent } from './candidates-tab/candidates-tab.component';
import { ActivatedRoute, Router } from '@angular/router';
import { PipesModule } from '../../../../../shared/pipes/pipes.module';
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { HelperService } from '../../../../../shared/services/helper.service';
import { CommonModule } from '@angular/common';
import { TabViewModule } from 'primeng/tabview';

@Component({
    selector: 'app-job-details',
    imports: [
        TabViewModule,
        CandidatesTabComponent,
        DetailsTabComponent,
        PipesModule,
        HeadingComponent,
        CommonModule,
        ButtonModule,
        TooltipModule
      ],
    templateUrl: './job-details.component.html',
    standalone: true,
    styleUrl: './job-details.component.scss'
})
export class JobDetailsComponent implements OnInit {

  job: any;
  jobId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    public helperService: HelperService,
    private router: Router
  ) { }

  ngOnInit(): void {
     this.jobId = this.route.snapshot.paramMap.get('jobId');
    if (history.state?.data) {
      this.job = history.state?.data;
    }
  }

  onEditJob($event: Event, $job: any) {
    $event.stopPropagation();
    this.router.navigate([`/client/jobs/edit/${$job._id}`]);
  }
}
